import { render } from "./MainPage.vue?vue&type=template&id=028a1686&scoped=true"
import script from "./MainPage.vue?vue&type=script&lang=js"
export * from "./MainPage.vue?vue&type=script&lang=js"

import "./MainPage.vue?vue&type=style&index=0&id=028a1686&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-028a1686"]])

export default __exports__